import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useCheckout = () => useSelector(store, (state) => state.context.checkout);
